import { useMutation } from '@tanstack/react-query';
import { updateUserLanguage } from '../../utils/react-query/query-functions';

export const useUpdateUserLanguage = () => {
  return useMutation({
    mutationKey: ['updateUserLanguage'],
    mutationFn: updateUserLanguage,
    retry: false, // Don't retry on failure to prevent multiple calls
  });
};
